import React, { useEffect, useState, useRef } from "react";
import logo from "../../asset/logo.jpg";
import "./header.css";
import { FaShoppingCart, FaUserCircle, FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import car from "../../asset/sport-car.png";
import bike from "../../asset/bike.png";
import { getGuestCart } from "../Cart/cartStorage";

function Header() {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [user, setUser] = useState(null);
  console.log("uuser", user);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  /* ================= CART COUNT ================= */
  useEffect(() => {
    const fetchCartCount = async () => {
      const token = localStorage.getItem("access");

      if (token) {
        try {
          const res = await axiosInstance.get("/cart/cart/");
          const total = res.data.reduce((sum, item) => sum + item.quantity, 0);
          setCount(total);
        } catch {
          setCount(0);
        }
      } else {
        const guestCart = getGuestCart();
        const total = guestCart.reduce((sum, item) => sum + item.quantity, 0);
        setCount(total);
      }
    };

    fetchCartCount();
    window.addEventListener("cartUpdated", fetchCartCount);
    return () => window.removeEventListener("cartUpdated", fetchCartCount);
  }, []);

  /* ================= USER PROFILE ================= */
  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("access");
      if (!token) {
        setUser(null);
        return;
      }

      try {
        const res = await axiosInstance.get("/accounts/profile/");
        setUser(res.data);
      } catch {
        setUser(null);
      }
    };

    fetchUser();
    window.addEventListener("authChanged", fetchUser);
    return () => window.removeEventListener("authChanged", fetchUser);
  }, []);
useEffect(() => {
  setMenuOpen(false);
}, [navigate]);
  /* ================= LOGOUT ================= */
  const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    setUser(null);
    setCount(0);
    window.dispatchEvent(new Event("authChanged"));
    navigate("/login");
  };

  /* ================= CLOSE MENU WHEN CLICK OUTSIDE ================= */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="header">
      {/* LOGO */}
      <img src={logo} alt="logo" className="logo" onClick={() => navigate("/")} />

      {/* ROAD (DESKTOP ONLY) */}
      <div className="road-wrapper">
        <div className="road-container">
          <div className="road-line"></div>

          <div className="bike-wrapper">
            <span className="bike-sticker">Sticker Vanga...</span>
            <img src={bike} alt="bike" className="moving-bike" />
          </div>

          <div className="car-wrapper">
            <span className="car-sticker">Enga Pora</span>
            <img src={car} alt="car" className="moving-car" />
          </div>
        </div>
      </div>

      {/* RIGHT ACTIONS */}
      <div className="right-actions">
        {user?.is_superuser && (
          <FaUserShield
            size={28}
            className="admin-icon"
            onClick={() => navigate("/adminpage")}
          />
        )}

        {user ? (
          <div className="user-box" ref={menuRef}>
            <div
  className="user-pill"
  onClick={(e) => {
    e.stopPropagation();
    setMenuOpen((prev) => !prev);
  }}
>
              <FaUserCircle size={18} />
              <span>Hi, {user.name}</span>
            </div>

            <div className={`user-menu ${menuOpen ? "open" : ""}`}>
              {/* <span onClick={() => navigate("/profile")}>My Profile</span> */}
              <span
                onClick={() => {
                  setMenuOpen(false);
                  navigate("/orders");
                }}
              >
                My Orders
              </span>
              <span
                className="logout"
                onClick={() => {
                  setMenuOpen(false);
                  handleLogout();
                }}
              >
                Logout
              </span>
            </div>
          </div>
        ) : (
          <FaUserCircle
            size={26}
            className="login-icon"
            onClick={() => navigate("/login")}
          />
        )}

        <div className="cart-icon" onClick={() => navigate("/cart")}>
          <FaShoppingCart size={26} />
          {count > 0 && <span className="cart-count">{count}</span>}
        </div>
      </div>
    </div>
  );
}

export default Header;
